import { catchAxiosError } from 'utilities/axios';
import axiosInstance from 'api-services/api-client';

const BotSettingsService = {
  getAccessiblitySettings: async (id) => {
    return catchAxiosError(
      axiosInstance
        .get(`/admin/accessibility-settings/${id}`)
        .then((response) => {
          return response;
        })
        .catch((err) => {
          return err;
        }),
    );
  },

  updateBotAccessControl: async (id, payload) => {
    return catchAxiosError(
      axiosInstance
        .put(`/admin/update-accessibility-settings/${id}`, payload)
        .then((response) => {
          return response;
        })
        .catch((err) => {
          return err;
        }),
    );
  },

  updateBotSettings: async (id, payload) => {
    return catchAxiosError(
      axiosInstance
        .put(`/admin/update-chatbot-settings/${id}`, payload)
        .then((response) => {
          return response;
        })
        .catch((err) => {
          return err;
        }),
    );
  },
};

export default BotSettingsService;
